import { AppBar, Link, Toolbar } from '@mui/material';

const Footer = () => (
  <AppBar position="relative" color="primary">
    <Toolbar sx={{ backgroundColor: '#373737', justifyContent: 'center' }}>
      <Link underline="none" href="/impressum.html" color="inherit">
        Impressum
      </Link>
    </Toolbar>
  </AppBar>
);

export default Footer;
